import _ from 'lodash'
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { loadManageCampaignList, loadPendingCampaignList } from 'app/campaign/features/campaign.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { MerchandiseCardComponent } from '../merchandise-card/merchandise-card.component';
import { selectMerchandiseCampaignList } from 'app/campaign/features/campaign.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-merchandise-list',
  standalone: true,
  imports: [MerchandiseCardComponent,FormsModule,ReactiveFormsModule,CommonModule],
  templateUrl: './merchandise-list.component.html',
  styleUrl: './merchandise-list.component.scss'
})
export class MerchandiseListComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public merchandiseCampaigns: any[];
  public filteredMerchandiseCampaigns: any[];
  private merchandiseCampaignsSelector$ = this.store.pipe(
    select(selectMerchandiseCampaignList),
    takeUntilDestroyed()
  );

  public search = new UntypedFormControl('',[])
  constructor(
    private store:Store,
    private sharedService : SharedService
  )
  {}
  
  ngOnInit(): void {
    this.store.dispatch({
      type: loadManageCampaignList.type,
      payload: this.sharedService.token,
      campaignTypes:[1],
    });

    this.merchandiseCampaignsSelector$.subscribe(list => {
      this.merchandiseCampaigns = list;
      this.filteredMerchandiseCampaigns = [...list];//new reference
    })

    this.search.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(searchQuery => {
      this.filteredMerchandiseCampaigns = _.filter(this.merchandiseCampaigns, (c: any) => {
        return _.includes(c.name.toLowerCase(), searchQuery.toLowerCase())
      });
    }); 
  }
}
